import { useFormat } from '@ideavivat/vivat-2';
import { materialBrand } from './base';

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    production_type: {
      name: 'ประเภท',
      width: '5rem',
    },
    drawing_no: {
      name: 'Drawing No. / Part No.',
      width: '12rem',
    },
    description: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    materialBrand,
    amount: {
      name: 'จำนวน',
      width: '6rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    withdrawn_amount: {
      name: 'จำนวนที่เบิกไปแล้ว',
      width: '8rem',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
    },
  },
};
